import ComponentWithSocket from '../../../lib/component'
import { Component } from 'vue-property-decorator';

import * as Store from '../../../store';

import template from './list.vue';

import moment from 'moment'
import 'moment/locale/ro'
moment.locale('ro')

// Websockets
import { WebsocketsListener } from '../../../utils/ws';

@Component({
    mixins: [template]
})

export default class Auctions extends ComponentWithSocket {

    private auctions: any[] = [];

    constructor() {

        super();

        // Assign session values to store for global dispatch
        this.wsListener.onGet('auctions', (success: boolean, data: any) => {

            if (success) {

                this.auctions.splice(0, this.auctions.length);

                for (let auction of data.reverse()) {

                    auction.startDate = auction.startDate ? moment(auction.startDate) : undefined

                    this.auctions.push(auction)

                }

            }

        });

    }

    beforeRouteLeave(to: any, from: any, next: any) {
        this._beforeLeave(to, from)
        next()
    }

    mounted() {
        this.wsListener.sendGet('auctions');
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/views/auctions/list/index.ts